/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustReqVo
 */
export interface AdminStockAdjustReqVo {
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    userId: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    warehouseId: number;
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    skuId: number;
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    goodsId: number;
    /**
     * 调整原因，见 StockAdjustReasonEnum
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    reason: number;
    /**
     * 调整方向：1 增加 2 减少
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    direction: number;
    /**
     * 调整数量（正整数）
     * @type {number}
     * @memberof AdminStockAdjustReqVo
     */
    quantity: number;
    /**
     * 货位号；无货位时可不传或传空
     * @type {string}
     * @memberof AdminStockAdjustReqVo
     */
    locationNo?: string;
    /**
     * 箱号/唛头号，与初始化 batches.locations.boxNo 一致
     * @type {string}
     * @memberof AdminStockAdjustReqVo
     */
    boxNo: string;
}

/**
 * Check if a given object implements the AdminStockAdjustReqVo interface.
 */
export function instanceOfAdminStockAdjustReqVo(value: object): value is AdminStockAdjustReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('skuId' in value) || value['skuId'] === undefined) return false;
    if (!('goodsId' in value) || value['goodsId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('boxNo' in value) || value['boxNo'] === undefined) return false;
    return true;
}

export function AdminStockAdjustReqVoFromJSON(json: any): AdminStockAdjustReqVo {
    return AdminStockAdjustReqVoFromJSONTyped(json, false);
}

export function AdminStockAdjustReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'warehouseId': json['warehouseId'],
        'skuId': json['skuId'],
        'goodsId': json['goodsId'],
        'reason': json['reason'],
        'direction': json['direction'],
        'quantity': json['quantity'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'boxNo': json['boxNo'],
    };
}

export function AdminStockAdjustReqVoToJSON(json: any): AdminStockAdjustReqVo {
    return AdminStockAdjustReqVoToJSONTyped(json, false);
}

export function AdminStockAdjustReqVoToJSONTyped(value?: AdminStockAdjustReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'skuId': value['skuId'],
        'goodsId': value['goodsId'],
        'reason': value['reason'],
        'direction': value['direction'],
        'quantity': value['quantity'],
        'locationNo': value['locationNo'],
        'boxNo': value['boxNo'],
    };
}

